import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core'
import { DxDataGridComponent } from 'devextreme-angular';
import { FacilityService } from '../services/facility.service';
import { BidCompany } from '../types/BidCompany';
import { Facility } from '../types/Facility';
@Component({
    selector: 'bidcompany-search',
    templateUrl: './bidcompany-search.component.html',
    styleUrls: ['./bidcompany-search.component.scss']
})
export class BidCompanySearchComponent implements OnInit {
    @ViewChild("CompanyGrid", { static: false }) companyGrid: DxDataGridComponent;
    @ViewChild("BidCompanyGrid", { static: false }) bidCompanyGrid: DxDataGridComponent;
    @Input() bidCompanySearchVisible: Boolean;
    @Input() facility: Facility;
    @Output() closeEvent = new EventEmitter<boolean>();
    @Output() saveEvent = new EventEmitter<BidCompany[]>();
    companyName: string;
    showCompanyErrorMsg: boolean = false;
    disableAddBtn: boolean = true;
    disableDeleteBtn: boolean = true;
    isLoadPanelVisible: boolean = false;
    companyList: BidCompany[];
    bidCompanies: BidCompany[] = [];
    constructor(private facilityService: FacilityService) {

    }

    ngOnInit(): void {
        if (this.facility.businessPotential.bidCompanies !== undefined && this.facility.businessPotential.bidCompanies.length > 0)
            this.bidCompanies = { ...this.facility.businessPotential.bidCompanies, ...this.bidCompanies }
    }

    companiesSelectionChangedHandler(e: any) {
        this.disableAddBtn = this.companyGrid.selectedRowKeys.length < 1;
    }

    bidCompanyChangedHandler(e: any) {
        this.disableDeleteBtn = this.bidCompanyGrid.selectedRowKeys.length < 1;
    }

    close() {
        this.closeEvent.emit(false);
    }

    save() {
        this.saveEvent.emit(this.bidCompanies);
    }

    addBidCompany() {
        var data = this.companyGrid.instance.getSelectedRowsData()[0];
        let bidCompany = new BidCompany();
        bidCompany.companyId = data.companyId;
        bidCompany.companyName = data.companyName;
        if (this.bidCompanies) this.bidCompanies.push(bidCompany);
        this.bidCompanyGrid.instance.refresh();
        this.companyList = this.companyList.filter(item => item.companyId !== bidCompany.companyId);
    }

    removeBidCompany() {
        var data = this.bidCompanyGrid.instance.getSelectedRowsData()[0];
        let bidCompany = new BidCompany();
        bidCompany.companyId = data.companyId;
        bidCompany.companyName = data.companyName;
        if (this.companyList) this.companyList.push(bidCompany);
        this.bidCompanies = this.bidCompanies.filter(item => item.companyId !== bidCompany.companyId);
    }

    searchCompanies() {
        if (this.companyName === undefined || this.companyName === null || this.companyName.length < 3) {
            this.showCompanyErrorMsg = true;
            return;
        } else {
            this.showCompanyErrorMsg = false;
            this.isLoadPanelVisible = true;
            this.facilityService.getBidCompnaies(this.companyName)
                .subscribe(
                    (data: BidCompany[]) => {
                        this.companyList = data;
                        this.isLoadPanelVisible = false;
                    }
                );
        }
    }

}